import React, { FC, useState, useCallback } from "react";
import { css } from "linaria";

import HeartIcon from "../Icons/Heart";
import colors from "../../utils/colorConstants";
import {
  useAddFavoritePackage,
  useRemoveFavoritePackage,
} from "../../hooks/useFavoritePackageIdsQuery";

import AuthenticationModal, { LOG_IN } from "../Modals/AuthenticationModal";

import { useAuthState } from "../../contexts/Auth/context";
import fastpanel from "../../utils/fastpanel";

const styles = {
  favoriteIcon: css`
    @media (hover: hover) and (pointer: fine) {
      &:hover path {
        fill: ${colors.paloma};
      }
    }
  `,
};

interface Props {
  className?: string;
  id: string;
  favorite?: boolean;
  stroke?: string;
}

const CardFavoriteButton: FC<Props> = ({ className, id, favorite = false, stroke }) => {
  const [activeAuthModal, setActiveAuthModal] = useState<string | undefined>(
    undefined
  );
  const [addFavoritePackage] = useAddFavoritePackage(id);
  const [removeFavoritePackage] = useRemoveFavoritePackage(id);
  const { isLoggedIn } = useAuthState();

  const toggleFavorite = useCallback(
    (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      if (favorite) {
        removeFavoritePackage();
      } else {
        addFavoritePackage();
        fastpanel({
          name: "pbr_add_favorite_success",
          data: { id, favorite_origin_area: "plp" },
        });
      }
    },
    [favorite, addFavoritePackage, removeFavoritePackage]
  );
  const launchLoginModal = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveAuthModal(LOG_IN);
  };
  const modalDismissed = (isLoggedIn: boolean) => {
    setActiveAuthModal(undefined);
    if (isLoggedIn) {
      addFavoritePackage();
    }
  };

  const clickCallback = isLoggedIn ? toggleFavorite : launchLoginModal;

  return (
    <>
      <div className={className} onClick={clickCallback} role="button" data-cnstrc-btn="add_to_wishlist">
        <HeartIcon
          width="1.5rem"
          height="1.5rem"
          fill={favorite ? colors.paloma : undefined}
          stroke={favorite ? colors.paloma : stroke}
          className={styles.favoriteIcon}
        />
      </div>
      {activeAuthModal && (
        <AuthenticationModal
          initialContent={activeAuthModal}
          isOpen={!!activeAuthModal}
          onDismiss={modalDismissed}
        />
      )}
    </>
  );
};

export default React.memo(CardFavoriteButton);
